import { toErrorMessage } from "../../../../components/Input/InstrumentSearch";
import { AdminInstrumentTodo } from "../../../../services/admin";
import {
  useRecordInstrumentPriceMutation,
  useRepairInstrumentListingMutation,
} from "../../../../services/instruments";
import { ManualPriceEntry } from "./types";

export const useManualPricingWrite = () => {
  const [recordPrice] = useRecordInstrumentPriceMutation();
  const [repairListing] = useRepairInstrumentListingMutation();

  return async (
    { id: instrumentId, symbol, manualPricingOnly }: AdminInstrumentTodo,
    entry: ManualPriceEntry,
  ): Promise<string | null> => {
    // The price goes first: marking removes the problem from the only screen that could still add one.
    try {
      await recordPrice({ instrumentId, ...entry }).unwrap();
    } catch (err: unknown) {
      return toErrorMessage(err);
    }
    if (manualPricingOnly) {
      return null;
    }
    try {
      await repairListing({ instrumentId, manualPricingOnly: true }).unwrap();
      return null;
    } catch (err: unknown) {
      return `The price was saved, but ${symbol} wasn't marked for manual pricing. ${toErrorMessage(err)}`;
    }
  };
};
